(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["product-upsell"] && !Shopify.designMode) return;
  try {
    const ING_BU_CART_ADD_EVENT_NAME = 'cart:update';
const ING_BU_PRODUCT_UPSELL_SELECTOR = '.js-ingbu-product-upsell-add';

document.addEventListener('click', async (event) => {
  const button = event.target.closest(ING_BU_PRODUCT_UPSELL_SELECTOR);
  if (!button) return;

  event.preventDefault();

  if (button.disabled) return;

  const variantId = String(button.dataset.variantId || '').trim();
  if (!variantId) return;

  const defaultLabel =
    button.dataset.defaultLabel || button.textContent.trim() || 'In den Warenkorb';

  try {
    button.disabled = true;
    ingbuCartUpsellSetButtonLabel(button, '…');

    const sectionIds = ingbuGetCartSectionIds();

    const addRes = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        id: variantId,
        quantity: 1,
        sections: sectionIds.join(','),
        sections_url: window.location.pathname,
      }),
      cache: 'no-store',
    });

    const addData = await addRes.json();

    if (!addRes.ok) {
      throw new Error(addData?.description || 'Produkt konnte nicht hinzugefügt werden.');
    }

    const cart = await ingbuGetCart();

    ingbuUpdateCartCountFromCart(cart);
    ingbuDispatchThemeCartUpdate(cart, addData.sections, variantId);

    const refreshedButton = document.querySelector(
      `${ING_BU_PRODUCT_UPSELL_SELECTOR}[data-variant-id="${variantId}"]`
    );

    if (refreshedButton) {
      ingbuCartUpsellSetButtonLabel(refreshedButton, 'hinzugefügt ✓');
      refreshedButton.disabled = true;

      setTimeout(() => {
        ingbuCartUpsellSetButtonLabel(refreshedButton, defaultLabel);
        refreshedButton.disabled = false;
      }, 1500);
    }
  } catch (error) {
    console.error('[Product Upsell] Fehler beim Add-to-Cart:', error);

    ingbuCartUpsellSetButtonLabel(button, '!');
    button.disabled = false;

    setTimeout(() => {
      ingbuCartUpsellSetButtonLabel(button, defaultLabel);
    }, 2000);
  }
});


function ingbuCartUpsellSetButtonLabel(button, label) {
  if (!button) return;

  const span = button.querySelector('span');
  if (span) {
    span.textContent = label;
  } else {
    button.textContent = label;
  }
}


function ingbuGetCartSectionIds() {
  const ids = new Set();

  document.querySelectorAll('cart-items-component[data-section-id]').forEach((element) => {
    const sectionId = element.dataset.sectionId?.trim();
    if (sectionId) ids.add(sectionId);
  });

  return Array.from(ids);
}


async function ingbuGetCart() {
  const res = await fetch('/cart.js', {
    headers: { Accept: 'application/json' },
    cache: 'no-store',
  });

  if (!res.ok) {
    throw new Error('Cart konnte nicht geladen werden.');
  }

  return await res.json();
}


function ingbuUpdateCartCountFromCart(cart) {
  const count = String(cart?.item_count || 0);

  document.querySelectorAll('.cart-bubble__text-count').forEach((el) => {
    el.textContent = count;
  });
}


function ingbuDispatchThemeCartUpdate(cart, sections, variantId) {
  document.dispatchEvent(
    new CustomEvent(ING_BU_CART_ADD_EVENT_NAME, {
      bubbles: true,
      detail: {
        resource: cart,
        sourceId: 'cart-upsell',
        data: {
          source: 'cart-upsell',
          variantId,
          itemCount: cart?.item_count || 0,
          sections: sections || {},
        },
      },
    })
  );
}
  } catch(e) { console.error(e); }
})();

})();
